import { ActivityIndicator } from '@farmersdog/corgi-x';

import { useRoute } from '../../static-context';
import { ContentTypeRenderer } from '../ContentTypeRenderer';
import { NotFound } from '../NotFound';

import styles from './Page.css';

import type { StaticPageProps } from '../../static-context';

export function Page({ url }: StaticPageProps) {
  const { document, loading } = useRoute({ url });

  if (loading) {
    return (
      <main className={styles.main}>
        <div className={styles.loading}>
          <ActivityIndicator mode="dark" />
        </div>
      </main>
    );
  }

  if (!document) {
    return (
      <main>
        <NotFound />
      </main>
    );
  }

  return (
    <main className={styles.main}>
      <ContentTypeRenderer document={document} />
    </main>
  );
}
